module.exports = __webpack_public_path__ + "img/SPOTV_K.fa2a3cbd.png";